import { render, staticRenderFns } from "./setCollectionAccount.vue?vue&type=template&id=54ba7732"
import script from "./setCollectionAccount.vue?vue&type=script&lang=js"
export * from "./setCollectionAccount.vue?vue&type=script&lang=js"
import style0 from "./setCollectionAccount.vue?vue&type=style&index=0&id=54ba7732&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ba7732')) {
      api.createRecord('54ba7732', component.options)
    } else {
      api.reload('54ba7732', component.options)
    }
    module.hot.accept("./setCollectionAccount.vue?vue&type=template&id=54ba7732", function () {
      api.rerender('54ba7732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimWorkOrder/components/setCollectionAccount.vue"
export default component.exports